import { render } from "./TenantBackup.vue?vue&type=template&id=6c123bc6&scoped=true"
import script from "./TenantBackup.vue?vue&type=script&lang=js"
export * from "./TenantBackup.vue?vue&type=script&lang=js"

import "./TenantBackup.vue?vue&type=style&index=0&id=6c123bc6&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c123bc6"]])

export default __exports__